export default {"src":"/_next/static/media/email-shield-icon.89f9b258.svg","height":119,"width":104,"blurWidth":0,"blurHeight":0};